import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonCloseDirective, ButtonModule, ImgModule, ModalModule, TableModule } from '@coreui/angular-pro';
import { ServerAuthUrlPipe } from 'auth';

import { I18nService } from 'i18n';
import moment from 'moment';
import { Logger } from 'shared';

@Component({
  selector: 'calendar-event-list-dialog',
  templateUrl: './event-list-dialog.component.html',
  styleUrls: ['./event-list-dialog.component.scss'],
  imports: [ RouterModule, CommonModule, ModalModule, TableModule, ButtonModule, ButtonCloseDirective, ImgModule, ServerAuthUrlPipe ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarEventListDialogComponent {
  @Input() display: boolean = false;
  @Input() events: any[] = [];
  @Output() displayChange = new EventEmitter<boolean>();

  protected logger = new Logger('CalendarEventListDialogComponent');
  
  constructor(private router: Router, private i18nService: I18nService) {
    this.logger = new Logger('CalendarEventListDialogComponent');
  }
  
  onDisplayChange(display: boolean) {
    this.displayChange.emit(display);
  }

  onEventClick(event: any) {
    if (event.media) {
      const type = event.media.type;
      if (type === 'conference' || type === 'media') {
        const language = this.i18nService.getLanguage();
        this.router.navigate([`/${language}/${type}`], { state: { data: event.media }});
      } else {
        this.logger.error(`Invalid media type: ${type}`);
      }
    }
  }

  formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    return moment(date).format('MMM D, HH:mm').toString();
    // return date.toLocaleString('en-US', {
    //   year: 'numeric',
    //   month: 'short',
    //   day: 'numeric',
    //   hour: '2-digit',
    //   minute: '2-digit',
    //   // second: '2-digit'
    // });
  }
}